var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkAsDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.5588 7.50027C15.8351 7.19167 15.8089 6.71752 15.5003 6.44123C15.1917 6.16493 14.7175 6.19113 14.4412 6.49973L11.0721 10.2629C10.3894 11.0254 9.9296 11.5363 9.53652 11.8667C9.16207 12.1814 8.94213 12.25 8.75 12.25C8.55787 12.25 8.33794 12.1814 7.96348 11.8667C7.5704 11.5363 7.11064 11.0254 6.42794 10.2629L5.55877 9.29209C5.28248 8.98349 4.80833 8.9573 4.49973 9.23359C4.19113 9.50988 4.16493 9.98403 4.44123 10.2926L5.34753 11.3049C5.98338 12.0152 6.51374 12.6076 6.99835 13.0149C7.51099 13.4458 8.06393 13.75 8.75 13.75C9.43607 13.75 9.98901 13.4458 10.5016 13.0149C10.9863 12.6076 11.5166 12.0152 12.1525 11.3049L15.5588 7.50027Z",
    fill: "#48995D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsDone);
export default __webpack_public_path__ + "static/media/mark-as-done.b32893c6457e3c35fe077ecfa8a0744c.svg";
export { ForwardRef as ReactComponent };